"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectedL1CategoriesAndTerminalNodesData = exports.selectActiveCatalog = exports.selectActiveCatalogRTK = void 0;
const react_redux_1 = require("react-redux");
const reselect_1 = require("reselect");
const selectors_1 = require("../selectors");
const reducer_1 = require("../shared/selected-l1-categories/reducer");
// RTK-compatible selector with proper RootState typing
const selectActiveCatalogRTK = (state) => {
    var _a;
    const enrichAI = (0, selectors_1.selectEnrichAI)(state);
    return enrichAI.catalogs[(_a = enrichAI.selectedEntities.selectedCatalog) === null || _a === void 0 ? void 0 : _a.id];
};
exports.selectActiveCatalogRTK = selectActiveCatalogRTK;
// Legacy selector
exports.selectActiveCatalog = (0, reselect_1.createSelector)(selectors_1.selectEnrichAI, ({ catalogs, selectedEntities: { selectedCatalog } }) => catalogs[selectedCatalog === null || selectedCatalog === void 0 ? void 0 : selectedCatalog.id]);
const selectSelectedL1CategoriesAndTerminalNodesData = (0, reselect_1.createSelector)(exports.selectActiveCatalog, (activeCatalog) => (activeCatalog === null || activeCatalog === void 0 ? void 0 : activeCatalog.selectedL1CategoriesAndTerminalNodes) || reducer_1.defaultSelectedL1CategoriesState);
const useSelectedL1CategoriesAndTerminalNodesData = () => (0, react_redux_1.useSelector)(selectSelectedL1CategoriesAndTerminalNodesData);
exports.useSelectedL1CategoriesAndTerminalNodesData = useSelectedL1CategoriesAndTerminalNodesData;
